export var ACTIONS = /*#__PURE__*/function (ACTIONS) {
  ACTIONS[ACTIONS["SET_PROVIDER"] = 0] = "SET_PROVIDER";
  ACTIONS[ACTIONS["FOCUS_BY_LOCALID"] = 1] = "FOCUS_BY_LOCALID";
  return ACTIONS;
}({});

// actions

// commands